// AI configuration constants
export const AI_CONFIG = {
  // Smart Sort thresholds
  MIN_RESULTS: 5,
  SLICE_MAX: 50,
  DEBOUNCE_MS: 350,
  TTL_MS: 600000, // 10 minutes
  DESCRIPTION_TRUNCATE: 200,
  
  // Request settings
  RETRY_COUNT: 1,
  BACKOFF_BASE_MS: 500,
  AI_REQUEST_TIMEOUT_MS: 5000,
  FAILURE_AUTO_DISABLE_AFTER: 2,
  
  // Model settings
  MAX_COMPLETION_TOKENS: 600,
  
  // Versioning
  SMART_SORT_VERSION: 'v1',
  
  // Cache settings
  CACHE_MAX_SIZE: 200
};

// Error codes for consistent handling
export const AI_ERROR_CODES = {
  TIMEOUT: 'TIMEOUT',
  SCHEMA_ERROR: 'SCHEMA_ERROR',
  RATE_LIMIT: 'RATE_LIMIT',
  MODEL_ERROR: 'MODEL_ERROR',
  INPUT_INVALID: 'INPUT_INVALID'
} as const;

// Latency buckets for telemetry
export const LATENCY_BUCKETS = {
  FAST: '<250ms',
  MEDIUM: '<500ms',
  SLOW: '<1000ms',
  VERY_SLOW: '>1000ms'
} as const;

export function getLatencyBucket(latencyMs: number): string {
  if (latencyMs < 250) return LATENCY_BUCKETS.FAST;
  if (latencyMs < 500) return LATENCY_BUCKETS.MEDIUM;
  if (latencyMs < 1000) return LATENCY_BUCKETS.SLOW;
  return LATENCY_BUCKETS.VERY_SLOW;
}